import React, {useRef} from 'react';
import {motion, useInView} from 'framer-motion';

import Button from '../common/Button';
import openNewWindow from '../../utils/openNewWindow';

import {useMediaQuery} from '../../hooks/useMediaQuery';
import styles from './styles/main-10.module.css';

import {ReactComponent as BigLogoImg} from '../../assets/common/big-logo.svg';

const easeInMotion = {
    ease: 'easeIn',
    duration: 0.8
};

export default function Main10() {
    const mobileSmall = useMediaQuery('(max-width: 480px)');
    const mobileMedium = useMediaQuery('(min-width: 481px) and (max-width: 768px)');

    const ref = useRef(null);
   
    const isInView = useInView(ref, {
        once: true,
        amount: mobileSmall ? 0.2 : (mobileMedium ? 0.5 : 0.8),
        margin: mobileMedium ? '-20px 0px' : '-100px 0px'
    });

  return (
    <div className={styles.wrapper} ref={ref}>
        <div className={styles.container}>
            <div>
                <BigLogoImg />
            </div>
            <motion.div
                className={styles.boxText}
                initial={{ opacity: 0 }}
                animate={isInView ? { opacity: 1 } : { opacity: 0 }}
                transition={easeInMotion}
            >
                <p>당신의 데이터는 이미 충분합니다.</p>
                <p>이제는 제대로 활용할 차례입니다!</p>
            </motion.div>
            <div className={styles.boxBtn}>
                <Button
                    text='DARVIS 시작하기'
                    width={mobileSmall ? '160px' : '200px'}
                    height='52px'
                    padding='12px 16px'
                    backgroundColor='#FFF'
                    border='none'
                    borderRadius='10px'
                    fontSize={mobileSmall ? '17px' : '20px'}
                    fontWeight='700'
                    textColor='#000'
                    onClick={() => openNewWindow('https://salesmap.kr/web-form/7e5a8e7c-449f-4e57-983e-1d21fff92ac6')}
                />
                <Button
                    text='컨설팅 신청'
                    width={mobileSmall ? '160px' : '200px'}
                    height='52px'
                    padding='12px 16px'
                    backgroundColor='#825DFC'
                    border='none'
                    borderRadius='10px'
                    fontSize={mobileSmall ? '17px' : '20px'}
                    fontWeight='700'
                    textColor='#FFF'
                    onClick={() => openNewWindow('https://salesmap.kr/web-form/7e5a8e7c-449f-4e57-983e-1d21fff92ac6')}
                />
            </div>
        </div>
    </div>
  );
}
